/* eslint-disable prettier/prettier */
import { MyThunkResult } from 'store';

import {
  doChangeLanguage,
  doLoadCountryList,
  doLoadingCountryList,
  doLoadNationalityCountryList,
  doLoadingNationalityCountryList,
  doLoadRestCountryList,
  doLoadingRestCountryList,
} from 'action-creators/i18n';
import { Country, NationalityCountry } from 'models/country';
import { Response } from 'models/response';
import { getAll } from 'services/countriesService';

import { profile, axiosConfig } from '../api';

export const setCountry =
  (country: Country): MyThunkResult<void> =>
  (dispatch) => {
    const current = {
      ...country,
      culture: country.culture,
      currency: country.currency,
      documentType: country.documentType,
    };
    sessionStorage.setItem('@currentCountry', JSON.stringify(current));
    dispatch(doChangeLanguage(current));
  };

export const fetchCountryList = (): MyThunkResult<Promise<void>> => (dispatch) => {
  dispatch(doLoadingCountryList(true));
  return profile.get<Response<Country[]>>('/country', axiosConfig).then((response) => {
    const { data } = response.data;
    dispatch(doLoadCountryList(data as Country[]));
  });
};

export const fetchCountryById = (id: string) => profile.get<Response<Country>>(`/country/${id}`, axiosConfig);

export const fetchNationalityCountryList = (): MyThunkResult<Promise<void>> => (dispatch) => {
  dispatch(doLoadingNationalityCountryList(true));
  return profile.get<Response<NationalityCountry[]>>('/Nationality', axiosConfig).then((response) => {
    const { data } = response.data;
    dispatch(doLoadNationalityCountryList(data as NationalityCountry[]));
  });
};

export const fetchRestCountryList = (): MyThunkResult<Promise<void>> => (dispatch) => {
  dispatch(doLoadingRestCountryList(true));
  return getAll().then((data) => {
    dispatch(doLoadRestCountryList(data));
  });
};
